import { QueryClient } from '@tanstack/query-core';
import { isHTTPError, isTimeoutError } from 'ky';

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            staleTime: 5 * 60 * 1000,
            retry: (failureCount, error) => {
                // A 4xx is deterministic — an auth wall, a missing video, a validation
                // error. The second request fails exactly like the first, so all the retry
                // buys is a second of skeleton before the error UI the user was going to
                // see anyway. Gated content makes 401/403/404 common here, so this is the
                // bulk of the wasted traffic.
                if (isHTTPError(error) && error.response.status < 500) return false;

                // ky already waited out `timeout` (30s). Retrying means ~60s of skeleton
                // before anything is rendered, which reads as a hung page.
                if (isTimeoutError(error)) return false;

                // What's left is worth one more go: 5xx, and the connection failures that
                // `networkMode: 'online'` doesn't already park (it pauses rather than
                // retries when the browser reports itself offline).
                return failureCount < 1;
            },
        },
    },
});
